import Component from "../component";
import Dropdown from "../../helpers/dropdown";
import { useState } from "../../utils/state";

export default class ListingManualSelect extends Component {
  constructor(...args) {
    super(...args);

    this._retrieveDOM();

    this.type = this.dom.component.dataset.type;
    this.filtersId = {};
  }

  _retrieveDOM() {
    this.dom.listCards = this.dom.component.querySelector(".js-container-cards");
    this.dom.filtersItems = this.dom.component.querySelectorAll(".js-filter-item");
    this.dom.btnFilters = this.dom.component.querySelector(".js-btn-filters");
    this.dom.closeFilters = this.dom.component.querySelectorAll(".js-close-filters");
    this.dom.popinFilters = this.dom.component.querySelector(".js-popin-filters");
    this.dom.resetBtn = this.dom.component.querySelector(".js-btn-reset");
    this.dom.searchBtn = this.dom.component.querySelector(".js-btn-search");
    this.dom.inputSearch = this.dom.component.querySelector(".js-input-search");
    this.dom.filterButton = this.dom.component.querySelector(".filter-button");
    this.dom.filterButtonDesktop = this.dom.component.querySelector(".filter-button-desktop");
    this.dom.validateButton = this.dom.component.querySelector(".js-validate-filters");
    this.dom.promoButton = this.dom.component.querySelector(".js-promo-button");
    this.dom.promoValue = this.dom.component.querySelector(".js-promo-value");
  }

  init() {

    this.state = {
      filters: useState({}),
      searchValue: useState('')
    }

    this.state.filters.subscribe(this._updateFilteredItems.bind(this));

    //Event click filters items
    for (let i = 0; i < this.dom.filtersItems.length; i++) {
      this.dom.filtersItems[i].addEventListener("click", this.manageFilters.bind(this));
    }

    //Set default filter without banner filter
    if (this.dom.component.dataset.defaultFilterId) {
      this.filtersId["type"] = {
        value: this.dom.component.dataset.defaultFilterId,
        name: this.dom.component.dataset.defaultFilterSlug,
        type: "taxo"
      };
    }

    if (this.dom.promoButton) {
      this.dom.promoButton.addEventListener("click", this._clickPromo.bind(this));
    }

    //Event click btn filters (only mobile)
    if (this.dom.btnFilters) {
      this.dom.btnFilters.addEventListener("click", this._managePopin.bind(this));
    }

    //Event click close filters (only mobile)
    if (this.dom.closeFilters) {
      for (let index = 0; index < this.dom.closeFilters.length; index++) {
        this.dom.closeFilters[index].addEventListener("click", this._closePopin.bind(this));
      }
    }

    //Event click btn search
    if (this.dom.searchBtn && this.dom.inputSearch) {
      this.dom.searchBtn.addEventListener("click", this._searchProcess.bind(this));

      if (this.dom.validateButton) {
        this.dom.validateButton.addEventListener("click", this._searchProcess.bind(this));
      }

      this.dom.inputSearch.addEventListener("keypress", event => {
        if (event.keyCode == 13) {
          this._searchProcess();
          this.dom.inputSearch.blur();
        }
      });
    }

    //Event click btn reset search
    if (this.dom.resetBtn && this.dom.inputSearch) {
      this.dom.resetBtn.addEventListener("click", this._resetSearch.bind(this));
    }

    if (this.dom.filterButton) {
      this.dom.filterButton.addEventListener("click", this._toggleFilters.bind(this));
    }
    if (this.dom.filterButtonDesktop) {
      this.dom.filterButtonDesktop.addEventListener("click", this._toggleFilters.bind(this));
    }

    if (this.dom.validateButton) {
      this.dom.validateButton.addEventListener("click", this._toggleFilters.bind(this));
    }
  }

  _clickPromo() {
    this.dom.promoButton.classList.toggle("active");
  }

  _toggleFilters() {
    this.dom.popinFilters.classList.toggle("show");
  }

  _searchProcess() {
    this.state.searchValue.update(this.dom.inputSearch.value);
  }

  _resetSearch() {
    this.dom.inputSearch.value = "";
    this.state.searchValue.update("");
  }

  manageFilters() {

    setTimeout(() => {
      const themeDom = this.dom.component.querySelector("input[name=category]:checked");
      const campusDom = this.dom.component.querySelector("input[name=campus]:checked");
      const typeDom = this.dom.component.querySelector("input[name=type]:checked");
      const trainingDom = this.dom.component.querySelector("input[name=trainings]:checked");
      const wordsDom = this.dom.component.querySelector("input[name=alphabet]:checked");
      const promoDom = this.dom.component.querySelector("input[name=promo]:checked");

      const currentFilters = { ...this.state.filters.value }

      if (themeDom) {
        currentFilters[themeDom.getAttribute("name")] = {
          value: themeDom.dataset.id,
          name: themeDom.dataset.catSlug,
          type: "taxo"
        };
      }

      if (typeDom) {
        currentFilters[typeDom.getAttribute("name")] = {
          value: typeDom.dataset.id,
          name: typeDom.dataset.catSlug,
          type: "taxo"
        };
      }

      if (campusDom) {
        currentFilters[campusDom.getAttribute("name")] = {
          value: campusDom.dataset.id,
          name: campusDom.getAttribute("name"),
          type: "meta"
        };
      }

      if (trainingDom) {
        currentFilters[trainingDom.getAttribute("name")] = {
          value: trainingDom.dataset.id,
          name: trainingDom.getAttribute("name"),
          type: "meta"
        };
      }

      if (wordsDom) {
        currentFilters[wordsDom.getAttribute("name")] = {
          value: wordsDom.dataset.id,
          name: wordsDom.dataset.catSlug,
          type: "taxo"
        };
      }

      if (promoDom) {
        currentFilters[promoDom.getAttribute("name")] = {
          value: promoDom.dataset.id,
          name: promoDom.dataset.catSlug,
          type: "taxo"
        };

        this.dom.promoButton.classList.remove("active");

        if (parseInt(promoDom.value)) {
          this.dom.promoValue.querySelector(".text").innerHTML = promoDom.value;
          this.dom.promoValue.classList.add("show");
        } else {
          this.dom.promoValue.classList.remove("show");
        }
      }

      this.state.filters.update(currentFilters);

    }, 100)

  }

  _updateFilteredItems() {

    const filters = this.state.filters.value;
    console.log(filters.campus, filters.type)
    const all = this.dom.listCards.querySelectorAll('& > li')
    all.forEach(li => li.classList.remove('hidden'))

    Object.values(filters).forEach(filter => {
      if(filter.value === '') return
      const selector = `& > li:not(:has([data-${filter.name}="${filter.value}"]))`
      const selected = this.dom.listCards.querySelectorAll(selector)
      selected.forEach(node => node.classList.add('hidden'))
    })
    
    const hiddens = this.dom.listCards.querySelectorAll('& > li.hidden')
    if( hiddens.length === all.length){
      this._addNoResult()
    }else{
      this._removeNoResult()
    }

  }

  _closePopin() {
    this.dom.popinFilters.classList.remove("show");
  }

  _managePopin() {
    this.dom.popinFilters.classList.add("show");
  }

  _addNoResult() {
    this.dom.component.classList.add("no-results");
  }

  _removeNoResult() {
    this.dom.component.classList.remove("no-results");
  }

  animateCard(el, delay) {
    setTimeout(() => {
      el.classList.remove("to-animate");
    }, delay);
  }

  unbind() {

    this.dom.filterButton.removeEventListener("click", this._toggleFilters.bind(this));
    this.dom.validateButton.removeEventListener("click", this._toggleFilters.bind(this));
    this.dom.promoButton.removeEventListener("click", this._clickPromo.bind(this));

    Object.values(this.state).forEach(subState => subState.unsubscribe())
  }

  /*
  init() {
  }
  bind() {
  }
  unbind() {
  }
  resize(width, height) {
  }
  */
}
